import { Component, Injector, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { FilesService } from '@services/files/files.service';
import { DashboardProfile } from '../../../dto/dashboardProfile';
import { DashboardService } from '../../../services/dashboard/dashboard.service';
import { UserDto } from '../../../dto/userDto';
import { CustomerDto } from '../../../dto/customerDto';
import { CashflowDto } from '@dto/cashflowDto';
import { CustomersService } from '@services/entity/customers.service';
import { UsersService } from '@services/entity/users.service';
import { ActivatedRoute } from '@angular/router';
import { error } from 'console';

@Component({
  selector: 'app-dashboard-profile',
  templateUrl: './dashboard-profile.component.html',
  styleUrls: ['./dashboard-profile.component.scss']
})
export class DashboardProfileComponent implements OnInit {

  public dashboardProfile: DashboardProfile;
  public picture;
  public emission: any;
  public tree: any;
  public user: UserDto;
  public customers: CustomerDto[];

  public cashflow: CashflowDto;
  public qrCodeIncome: number;
  public qrCodeExpenses: number;
  public autoBillingIncome: number;
  public autoBillingExpenses: number;
  public isEmsp: boolean = false;

  public isOperator: boolean

  constructor(
    private dashboardService: DashboardService,
    private authenticationService: AuthenticationService,
    private customerService: CustomersService,
    private userService: UsersService,
    private filesService: FilesService,
    public activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    public injector: Injector) { }

  ngOnInit(): void {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;

    if (this.isOperator){
      this.customerService.getMasterUserOfCustomer(this.activatedRoute.parent.snapshot.params.key).subscribe(masterUser => {
        this.userService.getUserDtoById(masterUser.id).subscribe(user => {
          this.user = user;
          this.dashboardService.getDashboardProfileOfCustomer(this.activatedRoute.parent.snapshot.params.key).subscribe(result => {
            this.dashboardProfile = result;
            this.dashboardProfile.subscriptionType = this.user.subscriptionTypeId;
            this.isEmsp = this.user.isEmsp;
            console.log(this.user);
            this.loadProfilePicture();
            this.getEmissionsData();
            this.getCashflow();
          }, error => {});
        }, error => {});
      })
    } else {
      this.dashboardService.getDashboardProfile().subscribe(result => {
        this.user = this.authenticationService.getLoggedInUser()
        this.dashboardProfile = result;
        this.dashboardProfile.subscriptionType = this.user.subscriptionTypeId;
        this.loadProfilePicture();
        this.getEmissionsData();
        this.getCashflow();
      }, error => {});
    } 
  }

  getEmissionsData() {
    this.emission = ((this.dashboardProfile.powerData * 3.6 * 94.1) / 1000 / 1000) - ((this.dashboardProfile.powerData * 3.6 * 119 * 0.4) / 1000 / 1000);

    this.tree = Math.floor(this.emission / 12.5);
    this.emission = this.emission / 1000;
  }

  isOperatorView(): boolean {
    return this.authenticationService.userHasRole("Operator");
  }

  isCustomerView(): boolean {
    return this.authenticationService.userHasRole("Customer") || this.authenticationService.userHasRole("Account") || this.isOperatorView();
  }

  isUserView(): boolean {
    return this.authenticationService.userHasRole("User");
  }

  loadProfilePicture() {
    if (this.dashboardProfile.pictureFileName) {
      this.filesService.getPicture(this.dashboardProfile.pictureFileName).subscribe(result => {
        var unsafeImageUrl = URL.createObjectURL(result);
        this.picture = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
      }, error => {})
    } else {
      console.warn(`User has no profile picture.`)
    }
  }

  getCashflow() {
    if (this.isCustomerView()) {
        this.dashboardService.getCashflowOfCustomer(this.user.selectedCustomerId).subscribe(cash => {
          this.cashflow = cash
        }, error => { console.log(error) })
      
    } else if (this.isUserView()) {
        this.dashboardService.getCashflowOfUser(this.user.id).subscribe(cash => {
          this.cashflow = cash
          if (this.cashflow.autoBillingExpenses > 0 && this.cashflow.autoBillingExpenses < 100) {
            this.cashflow.autoBillingExpenses = 100;
          }
        }, error => {console.log(error) })
    }
  }
}
